var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesequilibrioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C8.45 6 7.97917 5.80417 7.5875 5.4125C7.19583 5.02083 7 4.55 7 4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2C9.55 2 10.0208 2.19583 10.4125 2.5875C10.8042 2.97917 11 3.45 11 4C11 4.55 10.8042 5.02083 10.4125 5.4125C10.0208 5.80417 9.55 6 9 6ZM10 22V18.975C10.25 19.375 10.5458 19.7417 10.8875 20.075C11.2292 20.4083 11.6 20.7083 12 20.975V22H10ZM6 22V9C4.98333 8.91667 3.975 8.79583 2.975 8.6375C1.975 8.47917 0.983333 8.26667 0 8L0.5 6C1.9 6.38333 3.30417 6.64583 4.7125 6.7875C6.12083 6.92917 7.55 7 9 7C10.45 7 11.8792 6.92917 13.2875 6.7875C14.6958 6.64583 16.1 6.38333 17.5 6L18 8C17.0167 8.26667 16.025 8.47917 15.025 8.6375C14.025 8.79583 13.0167 8.91667 12 9V10.025C11.1 10.6083 10.375 11.3792 9.825 12.3375C9.275 13.2958 9 14.35 9 15.5V15.75C9 15.8333 9.00833 15.9167 9.025 16H8V22H6Z",
    fill: "#797D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6 22L17.9 19.3C17.5333 19.5333 17.15 19.7083 16.75 19.825C16.35 19.9417 15.9333 20 15.5 20C14.25 20 13.1875 19.5625 12.3125 18.6875C11.4375 17.8125 11 16.75 11 15.5C11 14.25 11.4375 13.1875 12.3125 12.3125C13.1875 11.4375 14.25 11 15.5 11C16.75 11 17.8125 11.4375 18.6875 12.3125C19.5625 13.1875 20 14.25 20 15.5C20 15.9333 19.9417 16.35 19.825 16.75C19.7083 17.15 19.5333 17.5333 19.3 17.9L22 20.6L20.6 22ZM15.3867 18C16.7674 18 17.8867 16.8807 17.8867 15.5C17.8867 14.1193 16.7674 13 15.3867 13C14.006 13 12.8867 14.1193 12.8867 15.5C12.8867 16.8807 14.006 18 15.3867 18Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesequilibrioIcon);
export default __webpack_public_path__ + "static/media/desequilibrio_icon.e8c37e25fdaab9c7facc172a3ae9cc48.svg";
export { ForwardRef as ReactComponent };